__turbopack_context__.v({
  "bar": "o-road-to-zero-module-scss-module__5WVGHq__bar",
  "counter": "o-road-to-zero-module-scss-module__5WVGHq__counter",
  "counter-wrapper": "o-road-to-zero-module-scss-module__5WVGHq__counter-wrapper",
  "placeholder": "o-road-to-zero-module-scss-module__5WVGHq__placeholder",
  "unit": "o-road-to-zero-module-scss-module__5WVGHq__unit",
  "value": "o-road-to-zero-module-scss-module__5WVGHq__value",
  "wrapper": "o-road-to-zero-module-scss-module__5WVGHq__wrapper",
});
